export type Market = 'wayke' | 'drive';

interface DomainMarketMap {
  [domain: string]: Market | undefined;
}

export type Locale = 'sv' | 'nb';

export const supportedLocales: Locale[] = ['sv', 'nb'];

type MarketLocaleMap = {
  [key in Market]: Locale;
};

const HostDevelopment = {
  wayke: 'localhost:5000',
  drive: 'localhost:5001',
};

const domainMarketMap: DomainMarketMap = {
  // Production domains
  'www.wayke.se': 'wayke',
  'wayke.se': 'wayke',
  'www.drive.no': 'drive',
  'drive.no': 'drive',
  // Staging domains
  'test.wayke.se': 'wayke',
  'test-www-ng.drive.no': 'drive',
  // Development domains
  [HostDevelopment.wayke]: 'wayke',
  [HostDevelopment.drive]: 'drive',
};

export const marketLocaleMap: MarketLocaleMap = {
  wayke: 'sv',
  drive: 'nb',
};

export const lowercasePrefixMarketMap: { [key in Market]: string } = {
  wayke: 'se',
  drive: 'no',
};

export const uppercasePrefixMarketMap: { [key in Market]: 'SE' | 'NO' } = {
  wayke: 'SE',
  drive: 'NO',
};

const domainHostnameMap: { [key in Market]: string } = {
  wayke: process.env.NEXT_WAYKE_URL || `http://${HostDevelopment.wayke}`,
  drive: process.env.NEXT_DRIVE_URL || `http://${HostDevelopment.drive}`,
};

export const isLocalhost = (hostname: string) =>
  hostname === HostDevelopment.wayke || hostname === HostDevelopment.drive;

export const resolveApiBaseUrl = (market?: Market) => {
  if (market) {
    return domainHostnameMap[market] || domainHostnameMap.wayke;
  }
  return typeof window === 'object' ? window.location.origin : '/';
};

export const resolveMarketFromHostname = (
  hostname: string | null,
  fallback: keyof typeof marketLocaleMap = 'wayke',
): Market => {
  const market = domainMarketMap[hostname as keyof DomainMarketMap];
  return market || fallback;
};

export const resolveLocaleFromHostname = (
  hostname: string | null,
  fallback: Locale = 'sv',
): Locale => {
  const market = domainMarketMap[hostname as keyof DomainMarketMap];
  const defaultLocale = marketLocaleMap[market as keyof MarketLocaleMap];
  return defaultLocale || fallback;
};

export default domainMarketMap;
